<template>
  <v-dialog
    v-model="tripFilterDialog"
    @submit="applyFilters()"
    @reset="resetFilters()"
    width="30%"
    ><v-card>
      <v-card-title>
        <v-row class="d-flex justify-space-between">
          <v-col cols="6">
            <h3 class="text-body-1 primary--text font-weight-bold">
              Trip Filter
            </h3>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <v-icon @click="tripFilterDialog = false" color="primary"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-form ref="tripFilterForm">
          <v-row no-gutters>
            <v-col cols="12" md="6" lg="6" xl="6" class="">
              <BaseDatePickerInput
                v-model="tripFilters.from_date"
                id="fromDateFilter"
                name="fromDateFilter"
                label="From Date"
                @change="syncTripFilters('from_date', $event)"
              ></BaseDatePickerInput>
            </v-col>
            <v-col cols="12" md="6" lg="6" xl="6" class="pl-2">
              <BaseDatePickerInput
                v-model="tripFilters.to_date"
                id="toDateFilter"
                name="toDateFilter"
                label="To Date"
                @change="syncTripFilters('to_date', $event)"
              ></BaseDatePickerInput>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <BaseSecondaryButton
          small
          customClass="rounded-lg"
          id="resetTripFilter"
          @click="resetFilters()"
          >Reset</BaseSecondaryButton
        >
        <BaseButton
          small
          customClass="rounded-lg"
          id="applyTripFilter"
          @click="applyFilters()"
          >Apply</BaseButton
        >
      </v-card-actions>
    </v-card></v-dialog
  >
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      tripFilters: {},
    };
  },
  watch: {
    tripFilterDialog(value) {
      if (value) {
        let filters = localStorage.getItem("tripFilters");
        if (!filters) {
          filters = {};
        }
        if (typeof filters == typeof "string") {
          filters = JSON.parse(filters);
        }
        this.tripFilters = filters;
      }
    },
  },
  computed: {
    tripFilterDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    syncTripFilters(key, value) {
      let filters = localStorage.getItem("tripFilters");
      if (!filters) {
        filters = {};
      }
      if (typeof filters == typeof "string") {
        filters = JSON.parse(filters);
      }
      if (value !== null && value.length > 0) {
        filters[key] = value;
      } else {
        delete filters[key];
      }
      this.tripFilters = filters;
      localStorage.setItem("tripFilters", JSON.stringify(filters));
    },
    applyFilters(reload) {
      this.$emit("tripFiltersChanged");
      this.tripFilterDialog = false;
    },
    resetFilters(reload) {
      this.tripFilters = {};
      localStorage.removeItem("tripFilters");
      this.$emit("tripFiltersChanged");
      if (this.$refs.tripFilterForm) {
        this.$refs.tripFilterForm.reset();
      }
    },
  },
};
</script>

<style>
</style>